import { ActivityEntityName } from '../../../../entities';
import { MergeDataset } from '../../decorators';
import { ContactMergeDataset } from './contact.merge.dataset';

@MergeDataset({
    entity: ActivityEntityName.LoginContact,
})
export class LoginContactMergeDataset extends ContactMergeDataset {
}
